import React from "react";
import { Helmet } from "react-helmet";

const PageTitle = ({ name }) => {
  return (
    <Helmet>
      <title>{name} - ORAM</title>
    </Helmet>
  );
};

export default PageTitle;
